import React, { useState } from "react";
import { BsFillPersonFill, BsFileEarmarkPerson } from "react-icons/bs";
import { FaPhone } from "react-icons/fa6";
import { RiTeamFill, RiLoginBoxLine, RiLogoutBoxLine } from "react-icons/ri";
import { PiCoffeeFill, PiNotepad } from "react-icons/pi";
import { CiMenuKebab } from "react-icons/ci";
import CustomModel from "../../components/common/CustomModel";

const UserBasicInfo = ({ employeeData }) => {
  const [isImageVisible, setIsImageVisible] = useState(false);
  const [isNoteVisible, setIsNoteVisible] = useState(false);
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
      <div className="flex items-stretch gap-6">
        {/* Avatar */}
        <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
          {employeeData?.user?.name ? employeeData.user?.name.charAt(0).toUpperCase() : "E"}
        </div>

        {/* Main Columns */}
        <div className="flex flex-1 items-stretch">
          {/* Employee Details */}
          <div className="flex-1 pr-4">
            <div className="grid grid-cols-4 gap-4">
              <div className="flex items-center gap-3">
                <span className="bg-green-50 rounded-full p-2 text-green-600">
                  <BsFillPersonFill className="text-xl" />
                </span>
                <div className="text-sm truncate line-clamp-2 text-gray-500">
                  Name: {employeeData?.user?.name || "Employee Name"}
                </div>
              </div>

              <div className="flex items-center gap-3">
                <span className="bg-green-50 rounded-full p-2 text-green-600">
                  <FaPhone className="text-xl" />
                </span>
                <div className="text-sm text-gray-500">
                  Phone No: {employeeData?.user?.phone || "+91 12345 67890"}
                </div>
              </div>



              <div className="flex items-center gap-3">
                <span className="bg-green-50 rounded-full p-2 text-green-600">
                  <BsFileEarmarkPerson className="text-xl" />
                </span>
                <div className="text-sm text-gray-500">Role: {employeeData?.user?.role}</div>
              </div>

              <div className="flex items-center gap-3">
                <span className="bg-green-50 rounded-full p-2 text-green-600">
                  <RiTeamFill className="text-xl" />
                </span>
                <div className="text-sm text-gray-500">Team: {employeeData.user?.team}</div>
              </div>

             
            </div>
          </div>

  


        </div>
      </div>

      <CustomModel
      isOpen={isImageVisible}
      onClose={() => setIsImageVisible(false)}
      title="Employee Image"
      content={
        <div className="flex justify-center items-center h-64">
          {employeeData?.user?.imageUrl ? (
            <img
              src={employeeData.user.imageUrl}
              alt="Employee"
              className="max-h-full max-w-full object-contain"
            />
          ) : (
            <div className="text-gray-500">No image available</div>
          )}
        </div>
      }
      />
      
    </div>
  );
};

export default UserBasicInfo;
